'use strict';
(function() {
    angular.module('cabinFlightAdmin').component('cabinFlightAdminComponent', {
        templateUrl: 'cabin-flight-admin/components/cabin-flight-admin-component.html',
        controller: function($timeout, $scope, $stateParams, $window, $interval, EventManagerService, MessageService, PopupManager, cabinFlightAdminService, CommonMasterData, crewScheduleService) {
            var vm = this;
            vm.model = {
                crewTypes: [],
                airports: [],
                crewNames: [],
                showSearchArea: true,
                view: "CABINFLIGHTADMIN",
                crewDetails: [],
                cabinCrewsDetails: [],
                feedbackRequiredInCabinFlightApproval: false,
                filteredCabinCrewsDetails: [],
                masterLists: [],
                departments:[],
                exportCabinFlightList : []
            };
            vm.searchParams = [];
            vm.filtersList = {
            		isShowAll : true,
            		isShowPending : false,
            		isShowMissng : false,
            		isShowApproved : false,
                isShowManuallySubmitted:false
            };
            vm.selectedRow = {};
            loadCrewTypes();
            loadAirports();
            loadCrewingPrivileges();
            responsiveStyles();
            loadDepartments();
            EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CABIN_FLIGHT_ADMIN.ALL, showAllCabinFlights);
            EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CABIN_FLIGHT_ADMIN.PENDING, showPendingCabinFlights);
            EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CABIN_FLIGHT_ADMIN.MISSING, showMissingCabinFlights);
            EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CABIN_FLIGHT_ADMIN.APPROVED, showApprovedCabinFlights);
            EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CABIN_FLIGHT_ADMIN.EXPORT, exportCabinFlights);
            EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.CABIN_FLIGHT_ADMIN.MANUALLY_SUBMITTED, showManuallySubmittedCabinFlights);

            function showAllCabinFlights() {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                removeClassTofilters();
                vm.model.filteredCabinCrewsDetails = [];
                vm.model.filteredCabinCrewsDetails = angular.copy(vm.model.cabinCrewsDetails);
                vm.filtersList = {
                		isShowAll : true,
                		isShowPending : false,
                		isShowMissng : false,
                		isShowApproved : false,
                    isShowManuallySubmitted:false
                };

                var elem = angular.element( document.querySelector('#allCabinFlights'));
                elem.addClass('selected-filter-border');

                $timeout(function(d) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                }, 1000)
            }

            function showPendingCabinFlights() {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                removeClassTofilters();
                vm.model.filteredCabinCrewsDetails = [];
                angular.forEach(vm.model.cabinCrewsDetails, function(flight) {
                    if (flight.status == "Pending Approval") vm.model.filteredCabinCrewsDetails.push(flight);
                });
                vm.filtersList = {
                		isShowAll : false,
                		isShowPending : true,
                		isShowMissng : false,
                		isShowApproved : false,
                    isShowManuallySubmitted:false
                };
                var elem = angular.element( document.querySelector('#pendingCabinFlights'));
                elem.addClass('selected-filter-border');

                $timeout(function(d) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                }, 1000)
            }

            function showMissingCabinFlights() {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                removeClassTofilters();
                vm.model.filteredCabinCrewsDetails = [];
                angular.forEach(vm.model.cabinCrewsDetails, function(flight) {
                    if (flight.status == "Missing") vm.model.filteredCabinCrewsDetails.push(flight);
                });
                vm.filtersList = {
                		isShowAll : false,
                		isShowPending : false,
                		isShowMissng : true,
                		isShowApproved : false,
                    isShowManuallySubmitted:false
                };
                var elem = angular.element( document.querySelector('#missingCabinFlights'));
                elem.addClass('selected-filter-border');

                $timeout(function(d) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                }, 1000)
            }

            function showApprovedCabinFlights() {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                removeClassTofilters();
                vm.model.filteredCabinCrewsDetails = [];
                angular.forEach(vm.model.cabinCrewsDetails, function(flight) {
                    if (flight.status == "Approved") vm.model.filteredCabinCrewsDetails.push(flight);
                });
                vm.filtersList = {
                		isShowAll : false,
                		isShowPending : false,
                		isShowMissng : false,
                		isShowApproved : true,
                    isShowManuallySubmitted:false
                };
                var elem = angular.element( document.querySelector('#approvedCabinFlights'));
                elem.addClass('selected-filter-border');

                $timeout(function(d) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                })
            }

            function exportCabinFlights(){
              createExportCabinFlightList();
              var cabinFlightData =  alasql("SELECT [num] as [#], [crewId] as [Crew ID], [crewName] as [Crew Name], [blockName] as [Flight], [flightNo] as [Flight#], [checkIn] as [Check In], [checkOut] as [Check Out],[status] as [Status], [submittedAt] as [Submitted At] FROM ? ", [vm.model.exportCabinFlightList]);
              var opts = [{sheetid:'Cabin Flight Report',header:true}];
              alasql("SELECT * INTO XLSX('cabin_flight_report'+ ? +'.xlsx',?) FROM ? ", [vm.searchParams.fromDate,opts,[cabinFlightData]]);
              clearData();
            }

            function createExportCabinFlightList() {
              for (var i = 0; i < vm.model.filteredCabinCrewsDetails.length; i++) {
                var resultData = {};
                resultData.num = i+1;
                resultData.crewId = vm.model.filteredCabinCrewsDetails[i].crewId;
                resultData.crewName = vm.model.filteredCabinCrewsDetails[i].crewName;
                resultData.blockName = vm.model.filteredCabinCrewsDetails[i].blockName != null ? vm.model.filteredCabinCrewsDetails[i].blockName : "";
                resultData.flightNo = vm.model.filteredCabinCrewsDetails[i].flightNo != null ? vm.model.filteredCabinCrewsDetails[i].flightNo : "";
                resultData.checkIn =  vm.model.filteredCabinCrewsDetails[i].checkInDate != null && vm.model.filteredCabinCrewsDetails[i].checkInTime != null ? vm.model.filteredCabinCrewsDetails[i].checkInDate + " " + vm.model.filteredCabinCrewsDetails[i].checkInTime : "";
                resultData.checkOut = vm.model.filteredCabinCrewsDetails[i].checkOutDate != null && vm.model.filteredCabinCrewsDetails[i].checkOutTime != null ? vm.model.filteredCabinCrewsDetails[i].checkOutDate + " " + vm.model.filteredCabinCrewsDetails[i].checkOutTime : "";
                resultData.status = vm.model.filteredCabinCrewsDetails[i].status != null ? vm.model.filteredCabinCrewsDetails[i].status : "";
                resultData.submittedAt = vm.model.filteredCabinCrewsDetails[i].submittedAtDate != null && vm.model.filteredCabinCrewsDetails[i].submittedAtTime != null ? vm.model.filteredCabinCrewsDetails[i].submittedAtDate + " " + vm.model.filteredCabinCrewsDetails[i].submittedAtTime : "";
                vm.model.exportCabinFlightList.push(resultData)
              }
            }

            function clearData() {
              vm.model.exportCabinFlightList = [];
            }

            function loadCrewTypes() {
                CommonMasterData.getCrewTypeList(function(crewTypes) {
                    vm.model.crewTypes = crewTypes.filter(
                    	    function (crewType) {
                    	        return (crewType.crewTypeMasterCode === 'CC');
                    	    }
                    	);
                }, function() {
                    console.log('Crew type retrieval error');
                });
            }

            function loadAirports() {
                CommonMasterData.getAirportList(function(airports) {
                    vm.model.airports = airports;
                }, function() {
                    console.log('airports retrieval error');
                });
            }
          function loadCrewingPrivileges() {
            cabinFlightAdminService.getCrewingPriviledges(function(crewingPrivileges) {
              vm.model.masterLists.cabinFlightReportEdit = crewingPrivileges.editCabinFlight;
            }, function() {
              console.log('privileges retrieval error');
            });
          }

          function loadDepartments(){
            cabinFlightAdminService.getDepartments(function(departments) {
              vm.model.departments = departments.deparmentDTOs;
            });
          }

            vm.onCabinCrewSearch = function(param,isNewSearch) {
                vm.searchParams = param;
                cabinFlightAdminService.searchCabinCrews(param, function(response) {
                    EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
                    responsiveStyles();
                    vm.model.filteredCabinCrewsDetails = [];
                    vm.model.cabinCrewsDetails = [];
                    removeClassTofilters();
                    vm.model.cabinCrewsDetails = response.cabinFlightReportCollection;
                    vm.model.feedbackRequiredInCabinFlightApproval = response.feedbackRequiredInCabinFlightApproval;
                    vm.model.filteredCabinCrewsDetails = angular.copy(vm.model.cabinCrewsDetails);
                    vm.model.showSearchArea = false;

                    if(!!isNewSearch){
                    	showAllCabinFlights();
                    }
                    else{
                    	setSelectedFilter();
                    }

                    $timeout(function(d) {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
                    }, 1000)
                }, function(error) {
                    MessageService.error(error.msg[0]);
                });
            }

            function loadCrewListByType(crewType) {
                var load = function() {
                    var param = {};
                    param.crewType = crewType;
                    param.active = true;
                    param.crewBase = '';
                    param.fleetExperince = '';
                    CommonMasterData.loadCrewList(param, function(response) {
                        vm.model.crewDetails = crewScheduleService.adaptCrewList(response);
                    }, function() {
                        console.log('Crew list retrieval error');
                    });
                };
                load();
            }
            vm.onChangeCrewType = function(crewType) {
                loadCrewListByType(crewType);
            };
            vm.clickOnRow = function(selectedRow, flag) {// var details = selectedRow;
                vm.model.showSearchArea = false;
                var details = {
                    "cabinFlightVersion": selectedRow.cabinFlightVersion,
                    "cabinFlightReportId": selectedRow.cabinFlightReportId,
                    "crewSchdBlockId": selectedRow.crewSchdBlockId,
                    "feedbackRequiredInCabinFlightApproval": vm.model.feedbackRequiredInCabinFlightApproval,
                    "aircraftModel": selectedRow.aircraftModel,
                    "crewPositions": selectedRow.crewPositions
                };

                if (flag == "EDIT") {
                    PopupManager.openModal('EDIT_CABIN_FLIGHT_DETAILS', details);
                } else if (flag == "DELETE") {
                    deleteCabinFlightDetails(details);
                } else if (flag === "VIEW") {
                  PopupManager.openModal('VIEW_CABIN_FLIGHT_DETAILS', details);
                } else if(flag === "row"){

                }else if (flag === "ADD_FEEDBACK"){
                  PopupManager.openModal('ADD_CABIN_FLIGHT_FEEDBACK', details);
                }else{
                  approveCabinFlightDetails(details);
                }
            };

          function onModalClose(isSuccess) {
            if(isSuccess){
              vm.onCabinCrewSearch(vm.searchParams);
            }
          }

          function approveCabinFlightDetails(approveCabinData) {
            if(approveCabinData.feedbackRequiredInCabinFlightApproval){ // feedback required
              approveCabinData.title = 'Confirmation';
              approveCabinData.messages = [MessageService.MESSAGES.CABIN_FLIGHT_ADMIN.APPROVE_CONFIRMATION];
              PopupManager.openModal('APPROVE_CABIN_FLIGHT_DETAILS', approveCabinData, onModalClose);
            } else {
              approveCabinFlight(approveCabinData);
            }
          }

          function approveCabinFlight(approveCabinData) {
            var param = {
              "cabinFlightVersion": approveCabinData.cabinFlightVersion,
              "cabinFlightReportId": approveCabinData.cabinFlightReportId,
              "crewSchdBlockId": approveCabinData.crewSchdBlockId,
              "feedback": ""
            };
            cabinFlightAdminService.approveCabinFlight(param, function(response) {
              if (response.success) {
                MessageService.success(MessageService.MESSAGES.CABIN_FLIGHT_ADMIN.APPROVE_SUCCESS);

                var position =  $(".fixed_header_table_inner_div").scrollTop();
                vm.onCabinCrewSearch(vm.searchParams);

                $timeout(function(){
                  $(".fixed_header_table_inner_div").scrollTop(position);
                },1000);

              }
            }, function(error) {
              if (error) error = error.msg[0];
              MessageService.error(error);
            });
          }

            function deleteCabinFlightDetails(details) {
            	vm.selectedRow = details;
            	var details = {
                        title: 'Confirmation',
                        messages: [MessageService.MESSAGES.CABIN_FLIGHT_ADMIN.DELETE_CONFIRMATION]
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', details, confirmDeletion);
            }

            function confirmDeletion(pass){
                if(pass=='YES'){
                	var param ={
                			"cabinFlightVersion": vm.selectedRow.cabinFlightVersion,
                			"cabinFlightReportId": vm.selectedRow.cabinFlightReportId
                			}
                	 cabinFlightAdminService.deleteCabinFlightEntry(param, function(response) {
                         if (response.success) {
                        	 MessageService.success(MessageService.MESSAGES.CABIN_FLIGHT_ADMIN.DELETE_SUCCESS);
                        	 vm.onCabinCrewSearch(vm.searchParams);
                         }
                     }, function(error) {
                         if (error) error = error.msg[0];
                         MessageService.error(error);
                     });
                }
            }

            function removeClassTofilters() {
                vm.model.showSearchArea = false;
                angular.element(".fixed_header_table_inner_div").scrollTop(0);
                var elem = angular.element( document.querySelector('#allCabinFlights'));
                elem.removeClass("selected-filter-border");

                elem = angular.element( document.querySelector('#pendingCabinFlights'));
                elem.removeClass("selected-filter-border");

                elem = angular.element( document.querySelector('#missingCabinFlights'));
                elem.removeClass("selected-filter-border");

                elem = angular.element( document.querySelector('#approvedCabinFlights'));
                elem.removeClass("selected-filter-border");

                elem = angular.element( document.querySelector('#manuallySubmittedCabinFlights'));
                elem.removeClass("selected-filter-border");
            }
            angular.element($window).bind('resize', function() {
                $timeout(function() {
                    responsiveStyles();
                }, 0);
            });

            function responsiveStyles() {
                var height = 70 + 40 + angular.element('div.profile-tab-header').height();
                angular.element(".search_panel_new").css("top", height);
                height = 70 + angular.element('div.profile-tab-header').height() + angular.element(angular.element('.toolbar-color')[0]).height();
                vm.model.masterLists.windowHeight = $window.innerHeight - height;
                vm.model.masterLists.toolbarHeight = angular.element(angular.element('.toolbar-color')[0]).height();
                vm.model.masterLists.outerDivWidth = $window.innerWidth - 75;
                if (vm.model.masterLists.outerDivWidth > 1000) vm.model.masterLists.innerDivWidth = vm.model.masterLists.outerDivWidth;
                else vm.model.masterLists.innerDivWidth = vm.model.masterLists.outerDivWidth + 70;
            }


          function showManuallySubmittedCabinFlights() {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, true);
            removeClassTofilters();
            vm.model.filteredCabinCrewsDetails = [];
            angular.forEach(vm.model.cabinCrewsDetails, function(flight) {
              if (flight.status == "Manually Submitted") vm.model.filteredCabinCrewsDetails.push(flight);
            });
            vm.filtersList = {
              isShowAll : false,
              isShowPending : false,
              isShowMissng : false,
              isShowApproved : false,
              isShowManuallySubmitted:true
            };
            var elem = angular.element( document.querySelector('#manuallySubmittedCabinFlights'));
            elem.addClass('selected-filter-border');

            $timeout(function(d) {
              EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
            })
          }

            function setSelectedFilter(){

            	if(!!vm.filtersList.isShowAll){
            		showAllCabinFlights();
            	}
            	else if(!!vm.filtersList.isShowPending){
            		showPendingCabinFlights();
            	}
            	else if(!!vm.filtersList.isShowMissng){
            		showMissingCabinFlights();
            	}
            	else if(!!vm.filtersList.isShowApproved){
            		showApprovedCabinFlights();
            	}else if(!!vm.filtersList.isShowManuallySubmitted){
                showManuallySubmittedCabinFlights();
              }
            }




        },
        bindings: {}
    });
})();
